<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="obj.title" :headText="obj.content"></titleHead>
    <div class="technology_content warp">
      <div class="technology_item">
        <div class="search_input">
          <input
            type="text"
            v-model="keyword"
            placeholder="请输入你要查询的关键字"
            @keyup.enter="getActivityList"
          />
          <button @click="getActivityList">
            <img src="../../assets/images/search.png" alt="" />
          </button>
        </div>

        <!--列表展示-->
        <div class="exhibition_item">
          <ul>
            <li
              v-for="(item, index) in exhibitionList"
              :key="index"
              @click="goToDetail(item)"
            >
              <div class="img">
                <p></p>
                <img :src="getImg(item.cover)" alt="" />
              </div>
              <div class="news_item_info">
                <p class="news_item_title">{{ item.title }}</p>
                <p>
                  <span>展馆名称:</span>
                  <span>{{ item.organization }}</span>
                </p>
                <p>
                  <span>举办时间:</span>
                  <span v-if="item.startdate">{{
                    item.startdate.substring(0, 10)
                  }}</span>
                </p>
                <p>
                  <span>举办地点:</span>
                  <span>{{ item.position }}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>

        <Pagination
          v-show="total > 0"
          :total="total"
          :page.sync="listQuery.curPage"
          :limit.sync="listQuery.limit"
          @pageChange="pageChange"
        ></Pagination>
      </div>

      <div class="technology_recommend">
        <!--展会资讯-->
        <newsRecom
          :newsRecommendObj="newsRecommendObj"
          @dataRefresh="getExhibitList(4)"
          urlType="exhibition_detail"
        ></newsRecom>
        <div class="find_right" v-if="advList.length > 0">
          <a :href="'//' + advList[0].url" target="_blank">
            <img :src="advList[0].image" alt="" />
            <span>广告</span>
          </a>
        </div>
        <!--最新展会-->
        <newsRecom
          :newsRecommendObj="newsRecommendObj2"
          @dataRefresh="getToppigList(4)"
          urlType="exhibition_detail"
        ></newsRecom>
      </div>
    </div>
  </div>
</template>

<script>
import { getDict } from "@/api/coment";
import { getRandomArray, routerGoNewpage } from "@/utils/index";
import { getActivityList, getAdv } from "@/api/information";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import newsRecom from "../../common/newsRecom";
import newsList from "../../components/newsList";
import Pagination from "../../components/Pagination";
export default {
  components: {
    commBanner,
    titleHead,
    newsRecom,
    newsList,
    Pagination,
  },
  provide: {
    urlType: "technology_detail",
  },
  data() {
    return {
      obj: {
        title: "平台展会",
        roleType: "",
        personalType: 2,
      },
      exhibitionList: [],
      current: 0,
      listQuery: {
        curPage: 1,
        limit: 5,
      },
      keyword: undefined,
      total: 0,
      newsRecommendObj: {
        title: "展会资讯",
        text: "换一批",
        isImg: true,
        newData: [],
      },
      newsRecommendObj2: {
        title: "最新展会",
        text: "换一批",
        isImg: false,
        newData: [],
      },
      advType: 4,
      advList: [],
      label: "",
      allList: [], //展会置顶
    };
  },
  created() {
    this.getActivityList();
    this.getExhibitionList();
    this.getAdv();
    this.getMate();
    if (this.$store.state.user.userInfo != null) {
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  computed: {
    dictList() {
      return this.$store.state.industry.list;
    },
  },
  methods: {
    //获取广告
    getAdv() {
      getAdv({
        curPage: 1,
        limit: 10,
        type: this.advType,
      }).then((res) => {
        if (res.code == 0) {
          this.advList = res.page.list;
        }
      });
    },
    setKeyword(item) {
      this.keyword = item.name;
    },

    //获取展会列表   //推荐
    getActivityList() {
      getActivityList({
        ...this.listQuery,
        recommend: 1,
        type: 1,
        keyword: this.keyword,
      })
        .then((res) => {
          if (res.code == 0) {
            this.exhibitionList = res.page.list;
            this.total = res.page.totalCount;
            this.getExhibitList(4);
          }
        })
        .catch((err) => {});
    },
    //获取置顶
    getExhibitionList() {
      getActivityList({
        ...this.listQuery,
        topping: 1,
        type: 1,
      })
        .then((res) => {
          if (res.code == 0) {
            this.allList = res.page.list;
            this.getToppigList(4);
          }
        })
        .catch((err) => {});
    },
    //展会详情
    goToDetail(data) {
      routerGoNewpage(`/exhibition_detail`, { id: data.id });
    },
    //随机获取推荐展会资讯
    getExhibitList(length) {
      this.newsRecommendObj.newData = _.compact(
        getRandomArray(_.cloneDeep(this.exhibitionList), length)
      );
    },

    getToppigList(length) {
      this.newsRecommendObj2.newData = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.getActivityList();
    },
    //seo
    getMate() {
      var metas = document.getElementsByTagName("meta");
      document.getElementsByTagName("title")[0].innerText =
        this.$route.meta.title + "_智污邦环保服务平台";
    },
    getImg(data) {
      let url = data.split(",");
      if (url.length > 2) {
        return url[1];
      } else if (url.length == 1) {
        return url[0];
      }
      return;
    },
  },
};
</script>

<style scoped lang="less">
.page {
  text-align: center;
  margin-top: 40px;
}
.technology_content {
  display: flex;
  .technology_item {
    width: 71%;
    margin-bottom: 40px;
    margin-right: 30px;
    .technology_search_criteria {
      display: flex;
      align-items: center;
      border-bottom: 1px dashed #e1e1e1;
      border-top: 1px dashed #e1e1e1;
      &:nth-of-type(2) {
        border-top: none;
      }
      .technology_search_tips {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333333;
        margin-right: 20px;
      }
      ul {
        display: flex;
        padding: 5px 0;
        li {
          width: 70px;
          text-align: center;
          cursor: pointer;
          margin-right: 20px;
          padding: 5px 0;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
          }
        }
        .active {
          transition: all 0.5s;
          background: #3bae30;
          border-radius: 3px;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 0;
          }
        }
        .actives {
          transition: all 0.5s;
          background: #3bae30;
          border-radius: 3px;
          span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;
            padding: 5px 0;
          }
        }
      }
    }
    .search_input {
      display: flex;
      input {
        flex: 7;
        border: 1px solid #65b62b;
        border-right: none;
        padding: 16px;
      }
      button {
        padding: 0 34px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        background: #3bae30;
        img {
          width: 21px;
          height: 21px;
        }
      }
    }
    .search_keywords {
      margin-top: 5px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      span {
        margin-right: 10px;
        cursor: pointer;
        &:first-of-type {
          margin-right: 0;
        }
      }
    }
  }
  .technology_recommend {
    // flex: 3;
    width: 27%;
  }
}
.find_right {
  margin-top: 10px;
  position: relative;
  margin-bottom: 10px;
}
.find_right img {
  width: 100%;
  height: 184px;
}
.find_right span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.mt-10 {
  margin-top: 10px;
}

/**列表样式 */
.exhibition_item {
  ul {
    li {
      // max-width: 757px;
      width: 100%;
      transition: all 0.5s;
      cursor: pointer;
      height: 175px;
      margin-top: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f8f8f8;
      padding: 15px;
      &:hover {
        box-shadow: 0 0 20px #ddd;
      }
      .img {
        width: 280px;
        height: 100%;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.5s;
          &:hover {
            transform: scale(1.2);
          }
        }
      }
      .news_item_info {
        display: flex;
        flex-direction: column;
        width: 60%;
        height: 100%;
        margin-left: 15px;
        .news_item_title {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          // 单行溢出省略
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        p {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #666666;
          margin-bottom: 15px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/other/exhibition_list.vue